import { render, staticRenderFns } from "./UserPicklDetailsPopupOverview.vue?vue&type=template&id=2310b2bc&scoped=true&"
import script from "./UserPicklDetailsPopupOverview.vue?vue&type=script&lang=js&"
export * from "./UserPicklDetailsPopupOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserPicklDetailsPopupOverview.vue?vue&type=style&index=0&id=2310b2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2310b2bc",
  null
  
)

export default component.exports